import { Button, Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { getSurfaceDoc } from './contentLoader';
import { InlineMd } from './markdown';
import type { SurfaceId } from './surfaceRegistry';

/**
 * Field-level help popover (OPSFL-HELP-1) fed from the surface doc's `## Inputs & fields`
 * entries, matched by field LABEL (case-insensitive). Modeled on `edu/FieldHelp` (which serves
 * capability-registry field help; this one serves the static per-page docs). Degrades: when the
 * surface doc or the field entry is missing, it renders NOTHING — icons simply don't appear.
 */
export function InfoTip({ surface, field }: { surface: SurfaceId; field: string }) {
  const doc = getSurfaceDoc(surface);
  const entry = doc?.fields.find((f) => f.label.toLowerCase() === field.toLowerCase());
  if (!entry) return null;

  return (
    <Popover
      title={entry.label}
      placement="topLeft"
      overlayStyle={{ maxWidth: 320 }}
      content={
        <div style={{ fontSize: 12.5, maxWidth: 300 }}>
          <InlineMd text={entry.body} />
        </div>
      }
    >
      <Button
        type="text"
        size="small"
        aria-label={`About the ${entry.label} field`}
        icon={<InfoCircleOutlined />}
        style={{ width: 18, height: 18, minWidth: 18, padding: 0, color: 'var(--ol-primary)' }}
      />
    </Popover>
  );
}
